// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CPatient_abstract } from './../abstract/SagaSchema/CPatient_abstract';
import { CPatientDestinationLocation } from './CPatientDestinationLocation';
import { CPatientLocation } from './CPatientLocation';
export class CPatient extends CPatient_abstract {
  get name(): string {
    return [this.Lname, this.Fname].filter(name => name).join(', ');
  }

  get location(): CPatientLocation {
    return this.component<any>(CPatientLocation).length ? this.component<CPatientLocation>(CPatientLocation)[0] : null;
  }

  get destinationLocation(): CPatientDestinationLocation {
    return this.component<any>(CPatientDestinationLocation).length
      ? this.component<CPatientDestinationLocation>(CPatientDestinationLocation)[0]
      : null;
  }
}
